import { useContext } from "react";
import { AppColorsContext } from "@/contexts/AppColors/AppColorsContext";

export const useAppColors = () => {
  const context = useContext(AppColorsContext);

  if (!context) {
    throw new Error(
      "useAppColors must be used within an AppColorsContextProvider",
    );
  }

  return context;
};
